<script lang="ts" setup>
import { storeToRefs } from "pinia";

import { TuiProgressSpinner } from "@vm/tui";

import CategoryAccordion from "./category-accordion.vue";
import EmptyState from "./empty-state.vue";

import { useComparisonStore } from "../comparison-store";

const comparisonStore = useComparisonStore();
const { allVizObjects, visibleObjects, isBusy, error } = storeToRefs(comparisonStore);

function onMove(nameA: string, nameB: string) {
  comparisonStore.moveObject(nameA, nameB);
}

function onRemove(name: string) {
  comparisonStore.removeObject(name);
}
</script>

<template>
  <div class="flex h-full flex-col">
    <div v-if="isBusy" class="flex flex-1 items-center justify-center py-12">
      <TuiProgressSpinner text="Data laden..." />
    </div>

    <div v-else-if="error" class="px-6 py-8 text-center text-sm text-red-600">
      {{ error }}
    </div>

    <div
      v-else-if="allVizObjects.length === 0"
      class="px-6 py-12 text-center text-sm text-gray-500"
    >
      Selecteer objecten in Tableau om de vergelijking te starten.
    </div>

    <EmptyState v-else-if="visibleObjects.length === 0" />

    <div v-else class="flex-1 overflow-auto">
      <CategoryAccordion
        :objects="visibleObjects"
        @move="onMove"
        @remove="onRemove"
      />
    </div>
  </div>
</template>
